import React from "react"
import PropTypes from "prop-types"
import Markdown from "@components/Markdown"

const CardWithIconTextDescription = ({
  iconDescription = "icon",
  icon,
  title,
  description,
  list = null,
  classes = {},
}) => (
  <div
    className={`flex flex-col items-center justify-center gap-5 xl:items-start ${classes?.parentContainer}`}
  >
    <figure className="h-20 w-20 desk:w-25 desk:h-25">
      <img className="w-full h-full" src={icon} alt={iconDescription} />
    </figure>
    <div>
      <h3
        className={`text-dblue font-inter 
      text-20 xl:text-32 font-normal xl:font-medium
      leading-120% xl:leading-normal mb-2 md:mb-3 xl:mb-4 ${classes?.title}`}
      >
        {title}
      </h3>
      <p className="text-bcoral font-inter text-14 xl:text-20 font-normal leading-150%">
        {description}
      </p>
      {list && (
        <ul className={list.class}>
          {list.items.map((item, index) => (
            <li key={index} className={item.class}>
              {item.hasHtml && <Markdown>{item.text}</Markdown>}
              {!item.hasHtml && item.text}
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
)

CardWithIconTextDescription.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  iconDescription: PropTypes.string,
  icon: PropTypes.string,
  list: PropTypes.object,
}

export default CardWithIconTextDescription
